import { render, staticRenderFns } from "./SystemTemplate.vue?vue&type=template&id=ae7390d0&"
import script from "./SystemTemplate.vue?vue&type=script&lang=js&"
export * from "./SystemTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports